import * as ActionTypes from '../constants/actionTypes'

export const openChangeMenu = openKeys => ({
  type: ActionTypes.ADMIN_OPENSUBMENU_CHANGE,
  openKeys,
})


// WEBPACK FOOTER //
// ./src/actions/admin.js